import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import { getResources } from 'services/app';

import { IResourceIndexParams, IResourceIndexResponse } from '../interfaces';

export default function useResources(
  params?: IResourceIndexParams,
  options?: Omit<
    UseQueryOptions<IResourceIndexResponse, Error, IResourceIndexResponse, QueryKey>,
    'queryKey'
  >
) {
  return useQuery<IResourceIndexResponse, Error>(
    [`resources`, params],
    () =>
      getResources(params).then((response) => {
        if (!response.ok) {
          throw new Error(response.originalError?.message);
        }

        return response.data;
      }),
    {
      ...options,
      cacheTime: 0,
      retry: false,
      staleTime: 0,
    }
  );
}
